<div class="game-card__time">
  <time class="time__start_date">{{ start | date }}</time>
  <div *ngIf="start" class="time__divider"></div>
  <time class="time__end_date">
    {{ end ? (end | date) : 'Not ending soon' }}
  </time>
</div>
